import { useId, useState } from 'react';
import { IconButton, Panel, CloseButton, Accordion, InputToggleGroup, Button } from '@ui/kit';
import { SettingsIcon } from '@ui/kit/icons';
import { useToggleState } from '@utils/react';
import { componentEntryStore } from '../../state.js';
import { panel, header, heading, closeButton, panels, listbox, submitButton } from './filters.mobile.style.js';
import { useFilterValues } from './hook.filters.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { timespanOptions } from '../../utils/timespan.js';

function MobileFilters(props) {
  const [showFilters, actions] = useToggleState();
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(IconButton, {
      active: showFilters,
      icon: /*#__PURE__*/jsx(SettingsIcon, {}),
      label: "\xC5bn filtreringspanel",
      onClick: actions.enable
    }), /*#__PURE__*/jsx(Panel, {
      active: showFilters,
      position: "right",
      onClose: actions.disable,
      children: /*#__PURE__*/jsx(PanelContent, {
        ...props,
        onClose: actions.disable
      })
    })]
  });
}
function PanelContent(props) {
  const componentId = useId();
  const timespanId = `timespan-${componentId}`;
  const teamsId = `teams-${componentId}`;
  const studentsId = `students-${componentId}`;
  const productsId = `products-${componentId}`;
  const {
    showTimespanThrobber,
    filters,
    options
  } = useFilterValues();
  const [expandedFilter, setExpanded] = useState("timespan");
  const toggleAccordion = nextValue => {
    setExpanded(prev => prev === nextValue ? undefined : nextValue);
  };
  return /*#__PURE__*/jsxs("div", {
    className: panel,
    children: [/*#__PURE__*/jsxs("header", {
      className: header,
      children: [/*#__PURE__*/jsx("h1", {
        className: heading,
        children: "Filtr\xE9r besvarelser"
      }), /*#__PURE__*/jsx(CloseButton, {
        className: closeButton,
        label: "Luk filtreringspanel",
        onClose: props.onClose
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: panels,
      children: [props.withTimespan && /*#__PURE__*/jsx(Accordion, {
        headingLevel: "h2",
        heading: "Periode",
        baseId: timespanId,
        expanded: expandedFilter === "timespan",
        onToggle: () => toggleAccordion("timespan"),
        children: /*#__PURE__*/jsx(InputToggleGroup, {
          id: `${timespanId}-content`,
          className: listbox,
          type: "radio",
          labelledBy: timespanId,
          selectedValues: [filters.timespan],
          options: timespanOptions,
          toggleValue: timespan => componentEntryStore.dispatch(componentEntryStore.actions.filterByTimespan(timespan))
        })
      }), props.withTeams && /*#__PURE__*/jsx(Accordion, {
        headingLevel: "h2",
        heading: "Klasser",
        baseId: teamsId,
        expanded: expandedFilter === "teams",
        onToggle: () => toggleAccordion("teams"),
        children: /*#__PURE__*/jsx(InputToggleGroup, {
          id: `${teamsId}-content`,
          className: listbox,
          labelledBy: teamsId,
          type: "checkbox",
          selectedValues: Object.keys(filters.teamIds),
          options: options?.teams ?? [],
          toggleValue: team => componentEntryStore.dispatch(componentEntryStore.actions.filterByTeam(team))
        })
      }), props.withStudents && /*#__PURE__*/jsx(Accordion, {
        headingLevel: "h2",
        heading: "Elever",
        baseId: studentsId,
        expanded: expandedFilter === "students",
        onToggle: () => toggleAccordion("students"),
        children: /*#__PURE__*/jsx(InputToggleGroup, {
          id: `${studentsId}-content`,
          className: listbox,
          labelledBy: studentsId,
          selectedValues: Object.keys(filters.studentIds),
          options: options?.students ?? [],
          type: "checkbox",
          toggleValue: student => componentEntryStore.dispatch(componentEntryStore.actions.filterByStudent(student))
        })
      }), props.withProducts && /*#__PURE__*/jsx(Accordion, {
        headingLevel: "h2",
        heading: "L\xE6remidler",
        baseId: productsId,
        expanded: expandedFilter === "products",
        onToggle: () => toggleAccordion("products"),
        children: /*#__PURE__*/jsx(InputToggleGroup, {
          id: `${productsId}-content`,
          className: listbox,
          labelledBy: productsId,
          selectedValues: Object.keys(filters.productIds),
          options: options?.products ?? [],
          type: "checkbox",
          toggleValue: product => componentEntryStore.dispatch(componentEntryStore.actions.filterByProduct(product))
        })
      })]
    }), /*#__PURE__*/jsx(Button, {
      className: submitButton,
      theme: "primary",
      onClick: props.onClose,
      disabled: showTimespanThrobber.current,
      tooltip: {
        disabled: !showTimespanThrobber.current,
        body: "Vent mens den valgte periode indlæses",
        ariaType: "description"
      },
      children: "Se besvarelser"
    })]
  });
}

export { MobileFilters };
//# sourceMappingURL=filters.mobile.js.map
